/**
 * Модели любят markdown, а мы показываем ответы как простой текст. Снимаем
 * разметку: жирный, код, заголовки и маркеры списка остаются читаемыми.
 */
export function plainText(value: string): string {
  return value
    .replace(/\*\*(.+?)\*\*/g, "$1")
    .replace(/__(.+?)__/g, "$1")
    .replace(/`([^`]+)`/g, "$1")
    .replace(/^#{1,6}\s+/gm, "")
    .replace(/^\s*[-*]\s+/gm, "— ")
    .trim();
}

const URL_RE = /(https?:\/\/[^\s<>"'()]+)/g;

export type TextSegment = { type: "text" | "url"; value: string };

export function splitLinks(text: string): TextSegment[] {
  const segments: TextSegment[] = [];
  let lastIndex = 0;
  for (const match of text.matchAll(URL_RE)) {
    const index = match.index ?? 0;
    if (index > lastIndex) segments.push({ type: "text", value: text.slice(lastIndex, index) });
    segments.push({ type: "url", value: match[0] });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) segments.push({ type: "text", value: text.slice(lastIndex) });
  return segments;
}
